import {
  CHECKBOX,
  RADIO,
  MULTI_SEARCH,
  DATE_RANGE,
  DROPDOWN,
  ADVANCED_FILTER_DEFAULT_OPTION_VALUE
} from '../constants';

// Values that mean "no filter": the shared 'ALL'/'All' sentinel and the empty null/'null'.
const isCatchAllValue = (value) => {
  if (value === null || value === undefined) {
    return true;
  }
  const normalised = String(value).toLowerCase();
  return (
    normalised === String(ADVANCED_FILTER_DEFAULT_OPTION_VALUE).toLowerCase() ||
    normalised === 'null'
  );
};

// A checkbox/dropdown group counts once if it holds any non-catch-all value.
const hasActiveSelection = (selectedValues) => {
  if (!Array.isArray(selectedValues)) {
    return Boolean(selectedValues) && !isCatchAllValue(selectedValues);
  }
  return selectedValues.some((value) => !isCatchAllValue(value));
};

// Radio/date-range/multi-search: active when the selection differs from its default facet,
// whose value may be comma-joined or the string 'null'.
const differsFromDefaultFacet = (defaultFacet, selectedValues) => {
  if (!Array.isArray(selectedValues) || !selectedValues.length) {
    return false;
  }
  if (!defaultFacet) {
    return true;
  }
  const defaultValue = String(defaultFacet.value);
  if (defaultValue.includes(',')) {
    return (
      !selectedValues.includes(defaultFacet.value.split(',')[0]) ||
      selectedValues.length > defaultFacet.value.split(',').length
    );
  }
  if (defaultValue === 'null') {
    return !selectedValues.includes(null) || selectedValues.length > 1;
  }
  return !selectedValues.includes(defaultFacet.value) || selectedValues.length > 1;
};

const getNumberOfActiveFilters = (filters, selectedFilters) => {
  let count = 0;

  if (Object.keys(selectedFilters).length === 0) {
    return count;
  }

  Object.keys(selectedFilters).forEach((selected) => {
    const filter = filters && filters.find((f) => f.name === selected);
    if (!filter) {
      return;
    }

    const { type, filterFacets } = filter;
    const upperType = type.toUpperCase();
    const values = selectedFilters[selected];

    if (upperType === CHECKBOX || upperType === DROPDOWN) {
      if (hasActiveSelection(values)) {
        count += 1;
      }
    } else if ([RADIO, MULTI_SEARCH, DATE_RANGE].includes(upperType)) {
      const defaultFacet =
      filterFacets && filterFacets.find((facet) => facet.selectedDefault);
      if (differsFromDefaultFacet(defaultFacet, values)) {
        count += 1;
      }
    } else if (Array.isArray(values) ? values.length > 0 : values) {
      count += 1;
    }
  });

  return count;
};

export { getNumberOfActiveFilters };
